import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { IoPersonOutline, IoDocumentTextOutline, IoCreate } from "react-icons/io5";
import { LuWarehouse } from "react-icons/lu";
import { FiLogOut } from "react-icons/fi";
import { FaUserGroup, FaUserClock, FaListUl } from "react-icons/fa6";
import { MdOutlineQuestionAnswer } from "react-icons/md";
import Logo from '../images/logo.png';

const navLinks = [
    { to: "/adminDashboard", label: "Dashboard", icon: <MdOutlineSpaceDashboard />, exact: true },
    { to: "/adminDashboard/warehouseList", label: "Warehouse List", icon: <LuWarehouse /> },
    { to: "/adminDashboard/createWarehouse", label: "Add Warehouse", icon: <IoCreate /> },
    { to: "/adminDashboard/userRequestList", label: "Quote Requests", icon: <FaUserClock /> },
    { to: "/adminDashboard/commonEnquiryList", label: "Enquiries", icon: <MdOutlineQuestionAnswer /> },
    { to: "/adminDashboard/requesterList", label: "Buyer Briefs", icon: <FaListUl /> },
    { to: "/adminDashboard/providerList", label: "3PL Providers", icon: <IoPersonOutline /> },
    { to: "/adminDashboard/createBlog", label: "Blog Post", icon: <IoDocumentTextOutline /> },
    { to: "/adminDashboard/userManagement", label: "User Management", icon: <FaUserGroup /> },
];

function Sidebar() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userType');
        navigate('/admin');
    };

    const isActive = (to, exact) => {
        if (exact) return pathname === to || pathname === to + '/';
        return pathname.startsWith(to);
    };

    return (
        <div className="sidebar" style={{ backgroundColor: "#132238", minHeight: "100vh", width: "220px", position: "sticky", top: 0 }}>
            <div style={{ padding: "1.25rem 1rem 0.5rem" }}>
                <img src={Logo} alt="3PL Search logo" style={{ height: "48px", marginBottom: "1rem" }} />
            </div>
            <ul className="list-unstyled mb-0">
                {navLinks.map(({ to, label, icon, exact }) => (
                    <li key={to} style={{ borderLeft: isActive(to, exact) ? "3px solid #0f766e" : "3px solid transparent" }}>
                        <Link
                            to={to}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.6rem",
                                padding: "0.65rem 1rem",
                                color: isActive(to, exact) ? "#fff" : "#a8bcd1",
                                textDecoration: "none",
                                fontSize: "0.875rem",
                                fontWeight: isActive(to, exact) ? "700" : "500",
                                background: isActive(to, exact) ? "rgba(15,118,110,0.15)" : "transparent",
                                transition: "background 0.15s, color 0.15s"
                            }}
                        >
                            <span style={{ fontSize: "1.1rem" }}>{icon}</span>
                            {label}
                        </Link>
                    </li>
                ))}
                <li style={{ borderTop: "1px solid rgba(255,255,255,0.08)", marginTop: "0.5rem" }}>
                    <button
                        onClick={handleLogout}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.6rem",
                            padding: "0.65rem 1rem",
                            color: "#a8bcd1",
                            background: "none",
                            border: "none",
                            width: "100%",
                            textAlign: "left",
                            fontSize: "0.875rem",
                            cursor: "pointer"
                        }}
                    >
                        <FiLogOut style={{ fontSize: "1.1rem" }} /> Logout
                    </button>
                </li>
            </ul>
        </div>
    );
}

export default Sidebar;
